/**
 * Canal de suporte — a saída de quem não consegue entrar.
 *
 * Não há recuperação de senha no clearance, e é decisão registrada, não
 * esquecimento: a recuperação é por e-mail e o buyer entra por telefone. Quem
 * esquece a senha depende de um operador redefinir. Sem um contato visível, o
 * usuário fica sem ação nenhuma na única tela que ainda consegue abrir.
 *
 * Reusa `VITE_CLOSER_WHATSAPP_PHONE`, que já é o número por onde o cliente
 * recebeu o link — o mesmo canal, e não um endereço novo para ele decorar.
 */

const RAW_PHONE = (import.meta.env.VITE_CLOSER_WHATSAPP_PHONE ?? '').replace(
  /\D/g,
  ''
);

/** Há contato configurado? Sem isso, a tela mostra texto em vez de link morto. */
export function hasSupportContact(): boolean {
  return RAW_PHONE.length > 0;
}

/**
 * Telefone legível a partir do E164 sem `+` (formato do `wa.me`).
 * `5511999999999` → `+55 11 99999-9999`. Formato inesperado sai como veio,
 * com `+` — melhor um número cru do que nenhum.
 */
export function supportPhoneLabel(): string | null {
  if (!RAW_PHONE) return null;
  const match = RAW_PHONE.match(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/);
  if (!match) return `+${RAW_PHONE}`;
  const [, country, area, prefix, suffix] = match;
  return `+${country} ${area} ${prefix}-${suffix}`;
}

/** Link do WhatsApp já com a mensagem, ou `null` se não há número. */
export function supportWhatsAppUrl(message: string): string | null {
  if (!RAW_PHONE) return null;
  return `https://wa.me/${RAW_PHONE}?text=${encodeURIComponent(message)}`;
}
